<template>
    <section class="app">
        <div class="row center-block">
            <!-- <h1 class="text-center">App</h1> -->
            <!-- <div class="col-md-12 divDeveloperDocumentation"> 
                 <h1 class="developerDocumentationSdk nuwaDevelop">{{$t('developer_documataion_overview_00_title')}}</h1>
            </div> -->
            <div class="col-md-12 divDeveloperDocumentationDownload"> 
            </div>
            <div class="col-md-12 div_path_3 divDeveloperDocumataion">
                <h1 class="developerDocumataionOverviewTitle nuwaDevelop">{{$t('developer_documataion_overview_01_title')}}</h1>
                <p class="developerDocumataionOverviewText ">
                    {{$t('developer_documataion_overview_01_text')}}
                </p>
            </div>
            <div class="col-md-12"><p class="Line_3"></p></div>
            <div class="col-md-12 div_path_3" style="padding-top: 47px;">
                <h1 class="developerDocumataionOverviewTitle nuwaDevelop">{{$t('developer_documataion_overview_02_title')}}</h1>
                <p class="developerDocumataionOverviewText ">
                    {{$t('developer_documataion_overview_02_text')}}
                </p>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
    
    }
</script>

<style scoped>
    
    @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

    table.dataTable thead .sorting:after,
    table.dataTable thead .sorting_asc:after,
    table.dataTable thead .sorting_desc:after {
        font-family: 'FontAwesome';
    }

    table.dataTable thead .sorting:after {
        content: "\f0dc";
    }

    table.dataTable thead .sorting_asc:after {
        content: "\f0dd";
    }

    table.dataTable thead .sorting_desc:after {
        content: "\f0de";
    }

    .addAppForm > .row {
        margin-top: 15px;
    }

    .addAppForm > .has-error3 input {
        background-color: #f8c9c8;
        border-color: #f18482;
        border-width: 2px;
    }

    #modal-add .modal-body, #modal-add .modal-footer {
        background-color: white !important;
        color: black !important;
    }
    #modal-add .btn-outline {
        color: black;
        border: 1px solid #3c8dbc;
    }

    /* [fu] */
 .col-md-12{
     padding-left: 0;
 }
 .main-sidebar{
     display: none!important;
 }
 .center-block{
     padding-top: 135px;
     margin-top: 0px;
 }
 .nuwaDevelop{
    margin: 0;
    }
.developerDocumentationSdk {
  width: 79%;
  height: 58px;
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
  color: var(--black);
  margin-bottom: 50px;
}
.divDeveloperDocumentationDownload{
  width: 79%;
  height: 230px;
  background-color: #d8d8d8;
  /* background-color: var(--white); */
  border: 1px solid;
  display: none;
  }
.divDeveloperDocumentation{
  display: flex;
  padding-left: 0;

}
.developerDocumataionOverviewTitle{
  width: 79%;
  /* height: 58px; */
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
  color: var(--black);
  padding-bottom: 5px;
}
.developerDocumataionOverviewText{
  width: 79%;
  /* height: 98px; */
  font-family: sans-serif;
  font-size: 22px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #333333;
  color: var(--black);
  margin-top: 8px;
  margin-bottom: 0;
}
.Line_3{
  width: 79%;
  height: 0.1px;
  opacity: 0.3;
  border: solid 1.6px #00e0da;
  /* border: solid 3px var(--aqua-blue-two); */
  margin-bottom: 0px;
}
.rectangle_9  {
  width: 220px;
  height: 50px;
  border-radius: 10px;
  background-color: #00b5e2;
  /* background-color: var(--aqua-blue); */
  outline: none;
  border: none;
}
.buttonTxt {
  width: 156px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  text-align: center;
  color: #ffffff;
}
.div_path_3 > button{
    margin-right:48px; 
}
/* .div_path_3{ */
    /* margin-top: 48px; */
/* } */
.divDeveloperDocumataion{
    padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// ListApp2.vue?08c73030